import { trackEvent } from "@trailhead/analytics";
import { AEClientType, TwilioClientType } from "@trailhead/chat";

export const triggerExpertMessagingOverlay = async (
  chatClient: TwilioClientType | AEClientType,
  initialText?: string,
  shouldAutoSendChatText = true,
  isOverlayAlreadyOpen = false,
) => {
  if (!isOverlayAlreadyOpen) {
    trackEvent("OpenExpertMessagingOverlayButtonClick", { initialText });
    await chatClient.openMessagingOverlay(initialText);
  }
  const inputElement = document.getElementById(
    "ae-sdk-timeline-message-box",
  ) as HTMLTextAreaElement;

  if (inputElement !== null) {
    if (initialText !== undefined) {
      inputElement.innerText = initialText;
      const event = new Event("input", {
        bubbles: true,
      });
      inputElement.dispatchEvent(event);
      if (shouldAutoSendChatText) {
        const sendButton = document.getElementsByClassName(
          "timeline-send-button",
        )[0] as HTMLButtonElement;
        sendButton.click();
      }
    } else {
      inputElement.innerText = "";
    }
  }
};
